module.exports = __webpack_public_path__ + "static/content-6411da32a409ed0ce214fa4af98d1b90.jpeg";